<div class="wrapper">
  <div>
    <!-- vcs.charging.mode -->
    <div class="feature-container" *ngIf="chargingModes$ | async as feature">
      <div class="feature-header">
        <h2>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_MODE_TILE' | translate }}</h2>
        <div class="flex flex-row items-center">
          <mat-form-field mat-select-height-small class="charging-form-field">
            <mat-select
              [value]="feature.properties?.value?.value"
              (selectionChange)="onChargingModeSelect($event.value)"
              fieldTextContentTooltip
            >
              <ng-container *ngFor="let mode of chargingModesArray">
                <mat-option
                  gtm="onSelect"
                  *ngIf="mode === wallboxChargingModes.SMART ? isSmartChargingModeVisible : true"
                  gtmAction="ChargingMode"
                  gtmCategory="hems"
                  fieldTextContentTooltip
                  [disabled]="
                    mode === wallboxChargingModes.SMART ? isSmartChargingModeDisabled : false
                  "
                  [value]="mode"
                >
                  {{ getModeLabel(mode) | translate }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="icon-description">
        <img class="icon" src="/assets/icons/wallbox/green-charging-icon.svg" />
        <div>
          <h4>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.GREEN_CHARGING_TITLE' | translate }}</h4>
          <p class="capitalize-first">
            {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.GREEN_CHARGING_CONTENT' | translate }}
          </p>
        </div>
      </div>
      <div class="icon-description">
        <img class="icon" src="/assets/icons/wallbox/mixed-charging-icon.svg" />
        <div>
          <h4>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.FAST_CHARGING_TITLE' | translate }}</h4>
          <p class="capitalize-first">
            {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.FAST_CHARGING_CONTENT' | translate }}
          </p>
        </div>
      </div>
      <div *ngIf="isSmartChargingModeVisible" class="icon-description">
        <img class="icon" src="/assets/icons/wallbox/smart-charging-icon.svg" />
        <div>
          <div class="flex flex-row items-center gap-2">
            <h4>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.TITLE' | translate }}</h4>
            <app-pill [type]="pillType.brand" class="smart-mode-pill">
              <mat-icon
                *ngIf="smartModeAvailability === SmartModeAvailability.noSubscription"
                class="pill-lock-icon"
                >lock</mat-icon
              >
              {{ '+HEMS.SETTINGS.OPTIMIZATIONS.DYNAMIC_ASSISTANT_PRO' | translate }}
            </app-pill>
          </div>
          <p class="capitalize-first">
            {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.DESCRIPTION' | translate }}
          </p>
          <app-banner *ngIf="isSmartChargingModeDisabled" type="info"
            >{{ smartChargingToolTipTranslationKey | translate }}
          </app-banner>
          <div class="flex flex-row justify-end items-center mt-2">
            <a
              class="settings-btn"
              (click)="openSettings()"
              gtm="onOpen"
              gtmAction="Smart charging settings"
              gtmCategory="installationDetails"
              >{{
                '+INSTALLATIONS.INSTALLATION.WALLBOX.SMART_CHARGING.SMART_MODE.SETTINGS' | translate
              }}
            </a>
            <mat-icon>keyboard_arrow_right</mat-icon>
          </div>
        </div>
      </div>
      <ng-container *ngIf="vehicleChargingStationAllowBatteryDischarge$ | async | ready as feature">
        <div class="feature-wrapper"></div>
        <div class="toggle-wrapper">
          <mat-slide-toggle
            [checked]="feature.properties?.active?.value"
            (click)="onVehicleChargingStation(feature)"
          ></mat-slide-toggle>
          <div class="toggle-content-wrapper">
            <div>
              <h3>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.USE_OF_BATTERY' | translate }}</h3>
            </div>
            <div>
              {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.USE_OF_BATTERY_DESCRIPTION' | translate }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div>
    <!-- vcs.control.charging.limit.base -->

    <div class="feature-container charging-limit" *ngIf="chargingLimit$ | async | ready as feature">
      <div class="feature-header">
        <h2>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.CURRENT_LIMIT' | translate }}</h2>
        <mat-form-field mat-select-height-small class="limit-form-field">
          <mat-select
            [value]="feature.properties?.value?.value"
            (selectionChange)="onChargingLimitSelect($event.value)"
            fieldTextContentTooltip
          >
            <mat-option
              gtm="onSelect"
              gtmAction="ChargingMode"
              gtmCategory="hems"
              fieldTextContentTooltip
              *ngFor="let limit of limits"
              [value]="limit"
            >
              {{ limit | suffix: SUFFIX.ampere }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <p class="limit-description">
        {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.CURRENT_LIMIT_DESCRIPTION' | translate }}
      </p>
      <app-banner type="info">{{
        '+INSTALLATIONS.INSTALLATION.WALLBOX.CURRENT_LIMIT_BANNER' | translate
      }}</app-banner>
    </div>

    <div class="feature-container" feature>
      <div class="feature-header">
        <h2>{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.DYNAMIC_FAULT_SWITCHOVER' | translate }}</h2>
      </div>
      <p class="limit-description">
        {{ '+INSTALLATIONS.INSTALLATION.WALLBOX.DYNAMIC_FAULT_SWITCHOVER_DESCRIPTION' | translate }}
      </p>
      <app-banner type="info">{{
        '+INSTALLATIONS.INSTALLATION.WALLBOX.DYNAMIC_FAULT_SWITCHOVER_BANNER' | translate
      }}</app-banner>
    </div>
  </div>
</div>
